export default __webpack_public_path__ + "static/media/verified_chillar.b525923d.png";